import {ActionTree, ActionContext} from 'vuex';

import {RootState} from '@/store';

import {State} from './state';
import {Mutations} from './mutations';
import {TranslationMutationTypes} from './mutation-types';
import {TranslationActionTypes} from './action-types';

import {Translations} from "@/types";

type AugmentedActionContext = {
    commit<K extends keyof Mutations>(
        key: K,
        payload?: Parameters<Mutations[K]>[1],
    ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, RootState>, 'commit'>

export interface Actions {
    [TranslationActionTypes.SET_TRANSLATIONS](
        {commit}: AugmentedActionContext,
        data: Translations
    ): void;
}

export const actions: ActionTree<State, RootState> & Actions = {
    [TranslationActionTypes.SET_TRANSLATIONS]({commit}, data: Translations) {
        commit(TranslationMutationTypes.SET_TRANSLATIONS, data);
    },
};